import { Router } from "@angular/router";
import { APIConstants } from "./app.constants";
import { OrderUtils } from "./pages/checkout-process/order-success/order-utils";
import { OrderService } from "./services/orders.service";
import { environment } from "src/environments/environment";
import { AuthService } from "./services/auth.service";
import { CookieService } from "ngx-cookie-service";
import { Overlay, OverlayPositionBuilder, OverlayRef } from "@angular/cdk/overlay";
import { ComponentPortal } from "@angular/cdk/portal";
import { DotElasticComponent } from "./dot-elastic/dot-elastic.component";
import { ExternalRouterService } from "./services/external-router.service";
import { OrderedCouponDto } from "./models/OrderDto";
declare var Razorpay: any;
export class Utils{
  static createSpinner(): any {
    
    let img = document.createElement("img");
    img.id = 'magic-spinner'
    img.src = '../../../../assets/spinner.svg'; 
    img.style.height = '30px';
    img.style.width= '30px'
    img.style.position = 'absolute';
    img.style.bottom ='0px';
    img.style.left='50%';
    return img;
  }
    public static phno= "phno";
    public  static readonly ELEMENT = {
        talkToExpert:"TALK_TO_EXPERT",
        contactForm: "CONTACT_FORM",
        standAChance: "STAND_A_CHANCE",
        coupon: "COUPON",
        ol_pocket: 'OL_POCKET'      // TODO add in phone-form-control
    }

    public static parseQuery(queryString) {
        var query = {};
        var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
        for (var i = 0; i < pairs.length; i++) {
            var pair = pairs[i].split('=');
            query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
        }
        return query;
    }

    public static getSource(url:any):string | undefined{
        let referrer = document.referrer;
        if(referrer){
            let x = new URL(referrer);
            let scheme = x.host;
            let domainName:string[]= scheme.split(".")
            let source = domainName[0]=='www' && domainName.length > 1? domainName[1]: domainName[0]
            return scheme;
        }
        
        let queryUrl = url.substring(url.indexOf("?")+1, url.length);
        let urlParams = new URLSearchParams(queryUrl);
        let source = urlParams.get("source");
        return source;
    }

    public static getReferer():string{
        return document.referrer;
    }

    public static newProduct(url:any):string | undefined{
        if(url == '/gps-product/ol-pocket'){
            return 'POCKET'
        }
        return null;
    }

    public static getLink(url:any):string | undefined{
        let queryUrl = url.substring(url.indexOf("?")+1, url.length);
        let urlParams = new URLSearchParams(queryUrl);
        let link = urlParams.get("utm_campaign");
        if(link ==null){
            link= urlParams.get("utmcampaign");
        }
        return decodeURIComponent(link);
    }

    public static getWhatAppHiiTextWithPhoneNo(){
        return encodeURI("https://wa.me/917217760961?text=Hi, I want to buy GPS tracker.");
    }

    public static getWhatAppHiiText(){
        return encodeURI("Hi, I want to buy GPS tracker");
    }

   public static magicLogin(){
    window.location.href = environment.CONTROL_UI_URL + "/login";
    }

    private static checkIfItIsQuickbuy(url:any):string{
        let queryUrl = url.substring(url.indexOf("?")+1, url.length);
        let urlParams = new URLSearchParams(queryUrl);
        let quickBuy = urlParams.get("quickbuyId");
        return quickBuy;
    }

    public static getMedium(url:any):string | undefined{
        let queryUrl = url.substring(url.indexOf("?")+1, url.length);
        let urlParams = new URLSearchParams(queryUrl);
        let medium = urlParams.get("utm_medium");
        if(medium == null){
            medium = urlParams.get("utmmedium");
        }
        return medium;
    }
    public static getSourcePage(url:any):string |undefined{
        return url.split("?")[0];
    }

    public static getLandingPage(url:any):string | undefined{
        return url.split("?")[0];
    }

    public static isLandedFromQuickBuyLink(externalRouter:ExternalRouterService){
        const quickBuyId = this.checkIfItIsQuickbuy(externalRouter.getUrl()[0]);
        let flag = false;
        if(quickBuyId !=null){
            flag = true;
            window.location.href = environment.CONTROL_UI_URL+"/qb?id="+quickBuyId;
        }
        return flag;
    }
    public static getDotElasticComponent(overlay:Overlay,positionBuilder:OverlayPositionBuilder):OverlayRef{
        const dialogPortal: ComponentPortal<DotElasticComponent> =
      new ComponentPortal(DotElasticComponent);
      const overlayRef = overlay.create({hasBackdrop:true, positionStrategy: positionBuilder
        .global()
        .centerHorizontally()
        .centerVertically() })
        overlayRef.attach<DotElasticComponent>(dialogPortal); 
        return overlayRef;
    }

    public static addToCartIfLandedFromQuickbuy(externalRouter:ExternalRouterService){
        this.isLandedFromQuickBuyLink(externalRouter);
    }

    public static buyNow(orders:OrderService, cartId, productId:string, router:Router,overlay:Overlay,positionBuilder:OverlayPositionBuilder, externalRouter:ExternalRouterService,magicOrderSpinner:OverlayRef ){
        if(this.isLandedFromQuickBuyLink(externalRouter)){
            return;
        }
        const btn = document.getElementById(productId) as HTMLButtonElement;
       
        const dialogPortal: ComponentPortal<DotElasticComponent> =
      new ComponentPortal(DotElasticComponent);
      const overlayRef = overlay.create({hasBackdrop:true, positionStrategy: positionBuilder
        .global()
        .centerHorizontally()
        .centerVertically() })
      

        const  RAZORPAY_OPTIONS = {
            key: APIConstants.KEY_RAZORPAY,
            amount: 0,
            currency: "INR",
            name: 'Onelap Telematics Pvt. Ltd.',
            order_id: '',
            description: 'Joining Onelap Family',
            image: 'https://www.onelap.in/assets/images/logo.png',
            prefill: {
              name: '',
              email: null,
              contact: '',
              method: ''
            },
            notes: {
              
            },
            modal: {},
            theme: {
              color: '#33c09b'
            },
            handler:undefined,
            one_click_checkout:true,
            callback_url: APIConstants.BASE_URL + "/magic-checkout/on-successful-payment"
          };
        orders.magicCheckout(cartId,productId).subscribe((res) => {
            magicOrderSpinner.detach();
      RAZORPAY_OPTIONS.order_id =res.attributes.razorpay_order_id;
      RAZORPAY_OPTIONS.amount = res.attributes.amount;
      (RAZORPAY_OPTIONS.modal as any).ondismiss = (() => {
      
      });
        RAZORPAY_OPTIONS.handler =  (response,err) =>{
        overlayRef.attach<DotElasticComponent>(dialogPortal);    
        const data = {
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_order_id: response.razorpay_order_id,
            razorpay_signature: response.razorpay_signature,
        };
        orders.captureMagicCheckoutPayament(data).subscribe(res=> {
            overlayRef.detach();
            router.navigate(["order-success", res.orderNo])
        }, err=>  {
            overlayRef.detach();
        })
      }
      const rzp = new Razorpay(RAZORPAY_OPTIONS);
      if(btn){
        btn.disabled = false;
      }
      rzp.open();
    } , err => {
        if(btn){
            btn.disabled = false;
        }
        magicOrderSpinner.detach()
      //this._onelapCheckoutLoginEventService.isPaymentTransactionEvent(false);
     // console.log(err);
    })

    }

    public static checkOutInDesktop(productId,cookie, externalRouter){
        let x = this.isLandedFromQuickBuyLink(externalRouter);
        if(x){
            return;
        }
        cookie.set("controlProductId", productId);
        window.location.href = environment.CONTROL_UI_URL + "/cart?productId="+productId;
    }

    public static checkOutInMobile(productId, authService:AuthService, cookieService:CookieService, externalRouter:ExternalRouterService){
        if(this.isLandedFromQuickBuyLink(externalRouter)){
            return;
        }
        cookieService.set("controlProductId", productId);
        let isAuth = authService.canActivate();
        if(isAuth){
            let auth = cookieService.get("Authorization");
            let userId = cookieService.get("UserID")
            auth = auth.substring("BEARER".length + 1)
            const isPhno = cookieService.check(Utils.phno);
            const phno = cookieService.get('phno')
            let uri =environment.CONTROL_UI_URL + "/cart?auth="+auth+"&userId="+userId+"&productId="+productId+"&phoneNumber="+phno;
            window.location.href = uri;
        }
    }

    public  static valueOfCoupon(coupon:OrderedCouponDto){
        if(coupon.couponType == 'TYPE_FLAT_OFF'){
            return coupon.couponFlatValue;
        }
        if(coupon.couponType == 'TYPE_MIN_OFF'){
            return coupon.couponMinOffValue;
        }
        if(coupon.couponType == 'TYPE_PERCENT_OFF'){
            return coupon.couponPercentValue;
        }
        if(coupon.couponType == 'SPECIAL_TYPE_FLAT_OFF'){
            return coupon.couponFlatValue;
        }
    }

}